import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
const programs = [{
  name: 'Kids Martial Arts',
  description: 'Structured martial arts training for children that builds discipline, confidence, and physical skills through age-appropriate instruction and progressive curriculum.',
  image: 'https://cdn.magicpatterns.com/uploads/rpUYVX6BTHcZD8MvBJVyvv/kids.jpg'
}, {
  name: 'Teen & Adult Classes',
  description: 'Comprehensive martial arts training for teens and adults focused on self-defense, fitness, and personal development through disciplined practice and skill progression.',
  image: 'https://cdn.magicpatterns.com/uploads/34YrwX6Uh42ERRoswozkZD/Teen-and-Adults.jpg'
}, {
  name: 'Brazilian Jiu-Jitsu',
  description: 'Ground-based grappling martial art that develops technical skill, strategic thinking, and physical conditioning through systematic training and live practice.',
  image: 'https://cdn.magicpatterns.com/uploads/aPhpJAWqY3QBXFC8MurJd8/bjj.jpg'
}, {
  name: 'Competition Team',
  description: 'Advanced training program for dedicated students pursuing competitive excellence in martial arts tournaments and demonstrations.',
  image: 'https://cdn.magicpatterns.com/uploads/dKu77WG1JfW9jNjCFoWbEn/competition.jpg'
}];
export function ProgramsPreview() {
  return <section className="py-20 bg-white border-y border-slate-100" data-id="element-369">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-370">
        <div className="text-center mb-12" data-id="element-371">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4" data-id="element-372">
            Our Programs
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-373">
            Structured martial arts training programs designed for different
            ages and skill levels, each emphasizing discipline, progression, and
            personal growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-374">
          {programs.map((program, index) => <div key={index} className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-375">
              {/* Program Image */}
              <div className="h-64 overflow-hidden" data-id="element-376">
                <img src={program.image} alt={program.name} className="w-full h-full object-cover object-center" data-id="element-377" />
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-378">
                <h3 className="text-xl font-bold text-[#1a2332] mb-3" data-id="element-379">
                  {program.name}
                </h3>
                <p className="text-slate-600 leading-relaxed text-sm" data-id="element-380">
                  {program.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-381">
          <Link to="/programs" data-id="element-382">
            <Button variant="outline" size="lg" className="border-[#1a2332] text-[#1a2332] hover:bg-[#1a2332] hover:text-white" data-id="element-383">
              View All Programs
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}